import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { AccountDetail, AccountAppAccess, AccountPlacement } from '../accountsApi';

interface Props {
    detail: AccountDetail;
}

/**
 * EAA-1820 (frame 72, tab Quyền theo đơn vị): every active placement plus
 * per-application roles resolved server-side — the fields the list row cannot carry.
 */
export function AccountProfilePermissionsTab({ detail }: Props) {
    const { t } = useTranslation();

    return (
        <div className="acc-profile-permissions">
            <section className="acc-profile-card">
                <h2 className="acc-profile-card__title">{t('console.accounts.profile.permissionsPlacementsTitle')}</h2>
                {detail.placements.length === 0 ? (
                    <p className="portal-accounts-unassigned">{t('console.accounts.detailDrawer.placementUnassigned')}</p>
                ) : (
                    <ul className="acc-profile-perm-list">
                        {detail.placements.map((p: AccountPlacement) => (
                            <li key={p.organization_id + p.level_name} className="acc-profile-perm-row">
                                <div>
                                    <strong>{p.organization_name}</strong>
                                    {p.level_name && (
                                        <span className="acc-profile-perm-level"> · {p.level_name}</span>
                                    )}
                                </div>
                                {p.role_key && <code className="acc-approle">{p.role_key}</code>}
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            <section className="acc-profile-card">
                <h2 className="acc-profile-card__title">{t('console.accounts.detailDrawer.appAccessLabel')}</h2>
                {detail.app_access.length === 0 ? (
                    <p className="portal-accounts-unassigned">{t('console.accounts.detailDrawer.noPermission')}</p>
                ) : (
                    <ul className="acc-profile-app-list">
                        {detail.app_access.map((app: AccountAppAccess) => (
                            <li key={app.application} className="acc-profile-app-row">
                                <div className="acc-profile-app-row__head">
                                    <strong>{app.application_name}</strong>
                                    <span className="acc-profile-app-code">{app.application}</span>
                                </div>
                                <div className="acc-profile-app-roles">
                                    {app.roles.map((role) => (
                                        <code className="acc-approle" key={role}>
                                            {role}
                                        </code>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            {detail.placements.length > 0 && (
                <p className="portal-admin-hint acc-profile-perm-hint">
                    {t('console.accounts.profile.permissionsHint')}{' '}
                    <Link to="/console/role-map">{t('console.accounts.profile.roleMapLink')}</Link>
                </p>
            )}
        </div>
    );
}

export default AccountProfilePermissionsTab;
